<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="pa-0" fluid >
    <v-row v-if="loading">
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-text>
            <v-progress-linear :indeterminate="true"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="emptyInsights">
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-text class="text-center">
            No hay datos por mostrar
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-row class="fill-height"   align="center" justify="space-between" >
          <v-col v-if="insights.totalProcessedAudios">
            <v-card>
              <v-card-title class="font-weight-bold">
                Audios Procesados
                <v-spacer></v-spacer>
                <v-icon color="green">cloud_upload</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="green"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.totalProcessedAudios.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.totalProcessedSeconds">
            <v-card>
              <v-card-title class="font-weight-bold">
                Segundos procesados
                <v-spacer></v-spacer>
                <v-icon color="amber lighten-2">watch_later</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="amber lighten-2"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.totalProcessedSeconds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.averageTimePerCall">
            <v-card>
              <v-card-title class="font-weight-bold">
                Tiempo Promedio por llamada
                <v-spacer></v-spacer>
                <v-icon color="blue">call</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="blue"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{`${insights.averageTimePerCall.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} seg`}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.percentageSilents">
            <v-card>
              <v-card-title class="font-weight-bold">
                Porcentaje de Silencios
                <v-spacer></v-spacer>
                <v-icon color="deep-orange darken-1">volume_off</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="deep-orange darken-1"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="parseFloat(insights.percentageSilents) * 100"
                    >{{(parseFloat(insights.percentageSilents) * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}%</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.averageConversations">
            <v-card>
              <v-card-title class="font-weight-bold">
                Conversaciones promedio
                <v-spacer></v-spacer>
                <v-icon color="total">record_voice_over</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="total"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.averageConversations.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.promiseCalls">
            <v-card>
              <v-card-title class="font-weight-bold">
                Llamadas tipo promesa
                <v-spacer></v-spacer>
                <v-icon color="amber lighten-2">call</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="amber lighten-2"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.promiseCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.negotiationCalls">
            <v-card>
              <v-card-title class="font-weight-bold">
                Llamadas tipo negociación
                <v-spacer></v-spacer>
                <v-icon color="green">record_voice_over</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="green"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.negotiationCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.reluctantCalls">
            <v-card>
              <v-card-title class="font-weight-bold">
                Llamadas tipo Renuente
                <v-spacer></v-spacer>
                <v-icon color="total">mdi-emoticon-confused</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="total"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.reluctantCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!--
          <v-flex>
            <v-card
              class="mx-auto"
            >
              <v-card-text style="text-align: center;">
                <p class="display-1 text--primary">
                  {{insights.totalProcessedSeconds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}
                </p>
                <v-divider class="ma-4"></v-divider>
                <div class="text--primary">
                  Segundos procesados
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          -->
          <v-col v-if="insights.averagePickupTime">
            <v-card>
              <v-card-title class="font-weight-bold">
                Tiempo promedio para contestar
                <v-spacer></v-spacer>
                <v-icon color="total">ring_volume</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      color="total"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.averagePickupTime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} seg</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.averageCallTime">
        <v-card class="mx-auto">
          <v-card-title class="justify-center font-weight-bold">Promedio de tiempo de llamada general</v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="{
                                chart: {
                                  type: 'boxplot'
                                },
                                title: {
                                  text: ''
                                },
                                legend: {
                                  enabled: false
                                },
                                xAxis: {
                                  categories: ['Todas las llamadas'],
                                  title: {
                                    text: ''
                                  }
                                },
                                yAxis: {
                                  title: {
                                    text: 'Tiempo'
                                  },
                                  plotLines: []
                                },
                                series: [{
                                  name: 'Tiempo',
                                  data: [
                                    [40, 178, 259, 487, 903]
                                  ],
                                  tooltip: {
                                    headerFormat: '<em>{point.key}</em><br/>'
                                  }
                                }],
                                credits: false
                              }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <!--
      <v-flex xs12 md8 lg7>
        <v-card class="fill-height">
          <v-card-title class="justify-center font-weight-bold">Oferta y Ventas</v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="{
                                chart: {
                                  type: 'bar'
                                },
                                title: {
                                  text: ''
                                },
                                subtitle: {
                                  text: `Para detectar una venta cruzada en las ${insights.sellAndOffer.conversations} conversaciones se analizaron las palabras y contextos de ofrecimiento tales como: Le gustaría, quisiera, su pedido, desearía, adiciona, agregaría, pago, número de guía e inclusive política de compra, en total el ${insights.sellAndOffer.portion.percentage.offerings * 100}% tuvo un ofrecimiento y un ${insights.sellAndOffer.portion.percentage.sell * 100}% cerró con venta.<br/><em>De las cuales Número de guía y política determinaron la compra.</em>`
                                },
                                xAxis: {
                                  categories: ['Llamadas', 'Ofrecimientos', 'Venta'],
                                  title: {
                                    text: null
                                  }
                                },
                                yAxis: {
                                  min: 0,
                                  title: {
                                    text: 'Palabras (Repeticiones)',
                                    align: 'high'
                                  },
                                  labels: {
                                    overflow: 'justify'
                                  }
                                },
                                tooltip: {
                                  valueSuffix: ' veces'
                                },
                                plotOptions: {
                                  bar: {
                                    dataLabels: {
                                      enabled: true
                                    }
                                  }
                                },
                                legend: {
                                  layout: 'vertical',
                                  align: 'right',
                                  verticalAlign: 'top',
                                  x: -40,
                                  y: 180,
                                  floating: true,
                                  borderWidth: 1,
                                  backgroundColor:
                                    Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
                                  shadow: true
                                },
                                credits: {
                                  enabled: false
                                },
                                series: [{
                                  name: 'Palabras',
                                  data: [insights.sellAndOffer.portion.count.calls, insights.sellAndOffer.portion.count.offerings, insights.sellAndOffer.portion.count.sell]
                                }]
                              }"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md3 lg2>
        <v-card class="fill-height">
          <v-card-title class="font-weight-bold">
            Tiempo adicional
            <v-spacer></v-spacer>
            <v-icon color="warning">watch_later</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout v-row wrap my-12 py-6>
              <v-flex xs12 text-xs-center>
                <v-progress-circular
                  color="warning"
                  :rotate="-90"
                  :size="100"
                  :width="15"
                  :value="100"
                >{{insights.averageSellCall.additionalTime}}x</v-progress-circular>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout v-row class="pt-6">
              <v-flex xs12>
                <p
                  :style="aditionalTimeStyle"
                >Tiempo adicional de una llamada con venta efectiva frente al total de las llamadas</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 lg6>
        <v-card text class="pa-0" color="rgb(255, 0, 0, 0)">
          <v-card-text class="pa-0">
            <v-layout v-row wrap fill-height>
              <v-flex xs12>
                <v-card>
                  <v-card-title class="justify-center font-weight-bold">Promedio de llamada con venta</v-card-title>
                  <v-divider class="mx-4"></v-divider>
                  <v-card-text>
                    <Chart
                      :options="{
                                    chart: {
                                      type: 'boxplot'
                                    },
                                    title: {
                                      text: ''
                                    },
                                    subtitle: {
                                      text: `Analizando las conversaciones que cerraron con venta, son mucho más amplias en su rango de cierre que las llamadas generales del segmento.`
                                    },
                                    legend: {
                                      enabled: false
                                    },
                                    xAxis: {
                                      categories: ['Efectiva', 'General'],
                                      title: {
                                        text: 'Tipo de Llamada'
                                      }
                                    },
                                    yAxis: {
                                      title: {
                                        text: 'Tiempo'
                                      },
                                      plotLines: []
                                    },
                                    series: [{
                                      name: 'Tiempo',
                                      data: [
                                        Object.values(insights.averageSellCall.effective),
                                        Object.values(insights.averageSellCall.general)
                                      ],
                                      tooltip: {
                                        headerFormat: '<em>Tipo de llamada: {point.key}</em><br/>'
                                      }
                                    }]
                                  }"
                    />
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md5 lg6>
        <v-card>
          <v-card-title class="justify-center font-weight-bold">Competencia</v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="{
                                chart: {
                                  type: 'bar'
                                },
                                title: {
                                  text: ''
                                },
                                subtitle: {
                                  text: `De las ${insights.rivalry.total} llamadas, en ${insights.rivalry.count} el cliente nombró alguna de las competencias, las que se tuvieron en cuenta fueron: ${insights.rivalry.rows.map(el => el.name).join(', ')}.`
                                },
                                xAxis: {
                                  categories: insights.rivalry.rows.map(el => el.name),
                                  title: {
                                    text: null
                                  }
                                },
                                yAxis: {
                                  min: 0,
                                  title: {
                                    text: 'Veces Nombrada',
                                    align: 'high'
                                  },
                                  labels: {
                                    overflow: 'justify'
                                  }
                                },
                                tooltip: {
                                  valueSuffix: ' veces nombrada'
                                },
                                plotOptions: {
                                  bar: {
                                    dataLabels: {
                                      enabled: true
                                    }
                                  }
                                },
                                legend: {
                                  enabled: false,
                                  layout: 'vertical',
                                  align: 'right',
                                  verticalAlign: 'top',
                                  x: -40,
                                  y: 180,
                                  floating: true,
                                  borderWidth: 1,
                                  backgroundColor:
                                    Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
                                  shadow: true
                                },
                                credits: {
                                  enabled: false
                                },
                                series: [{
                                  name: 'Veces Nombrada',
                                  data: insights.rivalry.rows.map(el => el.count)
                                }]
                              }"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="justify-center font-weight-bold">Inconformismo</v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <v-layout v-row wrap>
              <v-flex xs12 md6 lg6>
                <Chart
                  :options="{
                                    chart: {
                                      plotBackgroundColor: null,
                                      plotBorderWidth: null,
                                      plotShadow: false,
                                      type: 'pie'
                                    },
                                    title: {
                                      text: ''
                                    },
                                    tooltip: {
                                      pointFormat: '{series.name}: <b>{point.y}</b>'
                                    },
                                    plotOptions: {
                                      pie: {
                                        allowPointSelect: true,
                                        cursor: 'pointer',
                                        dataLabels: {
                                          enabled: true,
                                          format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                          style: {
                                            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                          }
                                        }
                                      }
                                    },
                                    series: [{
                                      name: 'Llamadas',
                                      colorByPoint: true,
                                      data: [{
                                        name: 'Insatisfacción en la Llamada',
                                        y: insights.unconformity.portion.total,
                                        sliced: true,
                                        selected: true,
                                        color: '#d13f2b'
                                      }, {
                                        name: '',
                                        y: (insights.unconformity.total - insights.unconformity.portion.total),
                                        color: 'rgb(65, 168, 128, 0.6)'
                                      }]
                                    }]
                                  }"
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <Chart
                  :options="{
                                  chart: {
                                    type: 'bar'
                                  },
                                  title: {
                                    text: ''
                                  },
                                  subtitle: {
                                    text: `De las ${insights.unconformity.total} llamadas se buscaron los siguientes contextos para determinar razones de insatisfacción: 'Mal Servicio', 'No tienen', 'Muy caro', 'Queda Lejos', 'Atendieron mal', 'Malos', 'Pésimos'. De las cuales ${insights.unconformity.portion.total} manifestaron alguna inconformidad.`
                                  },
                                  xAxis: {
                                    categories: insights.unconformity.portion.reason.map(el => el.name),
                                    title: {
                                      text: null
                                    }
                                  },
                                  yAxis: {
                                    min: 0,
                                    title: {
                                      text: 'Veces Dicho',
                                      align: 'high'
                                    },
                                    labels: {
                                      overflow: 'justify'
                                    }
                                  },
                                  tooltip: {
                                    valueSuffix: ' veces dicho'
                                  },
                                  plotOptions: {
                                    bar: {
                                      dataLabels: {
                                        enabled: true
                                      }
                                    }
                                  },
                                  legend: {
                                    enabled: false,
                                    layout: 'vertical',
                                    align: 'right',
                                    verticalAlign: 'top',
                                    x: -40,
                                    y: 180,
                                    floating: true,
                                    borderWidth: 1,
                                    backgroundColor:
                                      Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
                                    shadow: true
                                  },
                                  credits: {
                                    enabled: false
                                  },
                                  series: [{
                                    name: 'Veces Dicho',
                                    data: insights.unconformity.portion.reason.map(el => el.count)
                                  }]
                                }"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      -->
      <v-col cols="12" md="4" lg="3" v-if="insights.pickupTime">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Tiempo para contestar
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="responseTimeData"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.successStartConversation">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Inician correctamente la conversación
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'No',
                                  y: 28,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'Si',
                                  y: 72,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }],
                              credits: false
                            }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <!--
      <v-flex xs12 md4 lg3>
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Piden Tiempo de espera
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="requestedWaitTime"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 lg3>
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Silencios en la Conversación
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'Segundos promedio de silencio',
                                  y: 314,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'Segundos promedio de llamada',
                                  y: 674,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }]
                            }"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      -->
      <v-col cols="12" md="4" lg="3" v-if="insights.requestForWaitTime">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Piden Tiempo de espera
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'Si',
                                  y: 83,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'No',
                                  y: 17,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }],
                              credits: false
                            }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.waitTimes">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Tiempos de espera
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="waitTimes"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.justifiedWaitTime">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Justificación de tiempo de espera
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'No',
                                  y: 75,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'Si',
                                  y: 25,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }],
                              credits: false
                            }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.giveServiceTime">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Dan el número de servicio
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="giveServiceNumberData"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.inappropiateWords">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Palabras inadecuadas
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'Si',
                                  y: 37,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'No',
                                  y: 63,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }],
                              credits: false
                            }"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.allowedCloseCall">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Autorización de cierre
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart
              :options="closeAuthorizationData"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-if="insights.serviceSurvey">
        <v-card>
          <v-card-title class="justify-center font-weight-bold">
            Encuesta de Servicio
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <Chart  :options="{
                              chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                              },
                              title: {
                                text: ''
                              },
                              subtitle: {
                                text: ``
                              },
                              tooltip: {
                                pointFormat: '{series.name}: <b>{point.y}</b>'
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: 'pointer',
                                  dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                    style: {
                                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                  }
                                }
                              },
                              series: [{
                                name: '',
                                colorByPoint: true,
                                data: [{
                                  name: 'No',
                                  y: 2,
                                  sliced: true,
                                  selected: true,
                                  color: '#d13f2b'
                                }, {
                                  name: 'Si',
                                  y: 98,
                                  color: 'rgb(65, 168, 128)'
                                }]
                              }],
                              credits: false
                            }"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
// Highcharts 1st
import Highcharts from 'highcharts'
// then all Highcharts modules you will need
import { Chart } from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Networkgraph from 'highcharts/modules/networkgraph'
// import sandTheme from 'highcharts/themes/sand-signika'
More(Highcharts)
// sandTheme(Highcharts)
Networkgraph(Highcharts)

export default {
  components: { Chart },
  created () {
    console.log('this.insights')
    console.log(this.insights)
  },
  computed: {
    ...mapState({
      emptyInsights () {
        return this.isEmpty(this.insights)
      }
    })
  },
  data () {
    return {
      responseTimeData: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Tiempo']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Tiempos de respuestas'
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Menor a 15 segundos',
          data: [100]
        }, {
          name: 'Mayor a 15 segundos',
          data: [0]
        }],
        credits: false
      },
      requestedWaitTime: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Personas']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Porcentaje piden'
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Lo piden',
          data: [83]
        }, {
          name: 'No lo piden',
          data: [17]
        }]
      },
      waitTimes: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Tiempo']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Porcentaje'
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Mayor a 9 minutos',
          data: [19]
        }, {
          name: 'Entre 3 y 9 minutos',
          data: [35]
        },
        {
          name: 'Menor a 3 minutos',
          data: [46]
        }],
        credits: false
      },
      closeAuthorizationData: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Respuestas']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Autorizaron'
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Si',
          data: [42]
        }, {
          name: 'No',
          data: [58]
        }],
        credits: false
      },
      giveServiceNumberData: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Respuestas']
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Si',
          data: [51]
        }, {
          name: 'No',
          data: [49]
        }],
        credits: false
      },
      loadingInsights: true,
      aditionalTimeStyle: 'font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 500; -webkit-font-smoothing: antialiased',
      Highcharts
    }
  },
  methods: {
    isEmpty (obj) {
      return Object.entries(obj).length === 0 && obj.constructor === Object
    }
  },
  props: {
    insights: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
